module.exports = __webpack_public_path__ + "static/media/complete-rescheduling-background-mobile.84f68327.png";